import * as API from '@siloreal:shared:api';

const SILOBAG_CLOSE_ENDPOINT = '/silobags/massive_close';

export type CloseSilobagsServiceContract = {
  silobagIds: readonly string[];
  acceptProtocolInvalidation?: boolean;
  signal?: AbortSignal;
};

export type CloseSilobagsRequestBody = {
  silobags: Array<{ id: string }>;
  accept_protocol_invalidation: boolean;
};

export type CloseSilobagResult = {
  ID: string;
  status: string;
  message: string;
  silobag_data?: {
    silobag_data_status_id: number;
  };
};

export type CloseSilobagsResponse = CloseSilobagResult[];

export async function closeSilobagsService(
  contract: CloseSilobagsServiceContract
): Promise<CloseSilobagsResponse> {
  const body: CloseSilobagsRequestBody = {
    silobags: contract.silobagIds.map((id) => ({ id })),
    accept_protocol_invalidation: contract.acceptProtocolInvalidation ?? false,
  };
  const { data } = await API.http.fetch.post<CloseSilobagsResponse>(SILOBAG_CLOSE_ENDPOINT, {
    body,
    signal: contract.signal,
  });

  return data;
}
